import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { BreakConfigurationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ArchiveBreakModal from '../ArchiveBreakModal'
import BreakMenu from './Menu'

interface Props {
  breakConfiguration: BreakConfigurationFragment
}

const BreakCard = ({ breakConfiguration }: Props) => {
  const [archiveModalOpen, setArchiveModalOpen] = React.useState(false)

  return (
    <Box
      width="full"
      component="ul"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
      gapDivider
    >
      <Box
        component="li"
        flexDirection="row"
        justifyContent="spaceBetween"
        paddingY="s16"
        paddingX="s24"
        alignItems="center"
      >
        <Text size="300" weight="medium">
          {breakConfiguration.name}
        </Text>
        <Box flexDirection="row" alignItems="center" gap="s16">
          <Tag type={breakConfiguration.paid ? Tag.Types.lime : Tag.Types.malibu}>
            {breakConfiguration.paid ? i18n.t('break_types.paid') : i18n.t('break_types.unpaid')}
          </Tag>
          <BreakMenu setArchiveModalOpen={setArchiveModalOpen} />
        </Box>
        {archiveModalOpen && (
          <ArchiveBreakModal
            breakConfigurationId={breakConfiguration.id}
            name={breakConfiguration.name}
            archived={breakConfiguration.archived}
            setArchiveModalOpen={setArchiveModalOpen}
          />
        )}
      </Box>
    </Box>
  )
}

export default BreakCard
